import { render, staticRenderFns } from "./CNDonate.vue?vue&type=template&id=2ed111ee&scoped=true"
import script from "./CNDonate.vue?vue&type=script&lang=js"
export * from "./CNDonate.vue?vue&type=script&lang=js"
import style0 from "./CNDonate.vue?vue&type=style&index=0&id=2ed111ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed111ee",
  null
  
)

export default component.exports